export type ClientDeviceInfo = {
  OS: string;
  Device: string;
};

function getBrowserName(userAgent: string): string {
  if (/Edg\//.test(userAgent)) return "Edge";
  if (/OPR\//.test(userAgent) || /Opera/.test(userAgent)) return "Opera";
  if (/Chrome\//.test(userAgent) && !/Edg\//.test(userAgent)) return "Chrome";
  if (/Safari\//.test(userAgent) && !/Chrome\//.test(userAgent)) return "Safari";
  if (/Firefox\//.test(userAgent)) return "Firefox";
  return "Unknown Browser";
}

function getOsName(userAgent: string, platform: string): string {
  if (/iPhone|iPad|iPod/.test(userAgent)) {
    const match = /OS (\d+[_.]\d+(?:[_.]\d+)?)/.exec(userAgent);
    return match ? `iOS ${match[1].replace(/_/g, ".")}` : "iOS";
  }
  if (/Android/.test(userAgent)) {
    const match = /Android (\d+(?:\.\d+)?)/.exec(userAgent);
    return match ? `Android ${match[1]}` : "Android";
  }
  if (/Mac OS X/.test(userAgent)) {
    const match = /Mac OS X (\d+[_.]\d+(?:[_.]\d+)?)/.exec(userAgent);
    return match ? `macOS ${match[1].replace(/_/g, ".")}` : "macOS";
  }
  if (/Windows NT/.test(userAgent)) {
    const match = /Windows NT (\d+\.\d+)/.exec(userAgent);
    return match ? `Windows ${match[1]}` : "Windows";
  }
  if (/Linux/.test(userAgent)) return "Linux";
  return platform || "Unknown OS";
}

function getDeviceCategory(userAgent: string): string {
  if (/iPad|Tablet/.test(userAgent)) return "Tablet";
  if (/Mobile|iPhone|Android/.test(userAgent)) return "Mobile";
  return "Desktop";
}

export function getClientDeviceInfo(): ClientDeviceInfo {
  if (typeof navigator === "undefined") {
    return { OS: "Unknown OS", Device: "Unknown Device" };
  }

  const userAgent = navigator.userAgent;
  const platform = navigator.platform ?? "";
  const browser = getBrowserName(userAgent);
  const category = getDeviceCategory(userAgent);

  return {
    OS: getOsName(userAgent, platform),
    Device: `${category} ${browser}`.trim(),
  };
}
